import { useNavigate } from "react-router-dom";
import ServiceProvider from "../../models/serviceProvider";

const ServiceProviderLink: React.FC<{ serviceProvider: ServiceProvider }> = ({
  serviceProvider,
}) => {
  const navigate = useNavigate();

  const onLinkClick = () => {
    navigate(`/work/service-providers/${serviceProvider.idServiceProvider}`);
  };

  return (
    <div
      className="navlink"
      style={{ display: "inline-block" }}
      onClick={() => onLinkClick()}
    >
      {ServiceProvider.getName(serviceProvider)}
    </div>
  );
};

export default ServiceProviderLink;
